import PropTypes from 'prop-types';
import React from 'react';

import './TextArea.scss';

//@TODO deprecate
export default class TextArea extends React.PureComponent {
    static propTypes = {
        /**
         * Name of InputField
         */
        name: PropTypes.string.isRequired,
        /**
         * border style: css border style object
         */
        customStyle: PropTypes.object,
        /**
         * Text to be displayed inside a button
         */
        placeholder: PropTypes.string,
        /**
         * onChange handler
         */
        onChange: PropTypes.func,
        /**
         * text to be display in textarea
         */
        text: PropTypes.string,
        /**
         * row number
         */
        rows: PropTypes.number,
        /**
         * col number
         */
        cols: PropTypes.number,
        /**
         * default text to be displayed
         */
        value: PropTypes.string,
        /**
         * value for qa data attribute
         */
        qaDataAttr: PropTypes.string,
        /**
         * on focus function
         */
        onFocus: PropTypes.func,
        /**
         * refs
         */
        refs: PropTypes.func,
        /**
         * class
         */
        class: PropTypes.string,
        /**
         * id
         */
        id: PropTypes.string,
        /**
         * on blur functino
         */
        onBlur: PropTypes.func,
    };

    static defaultProps = {
        customStyle: {},
        placeholder: '',
        onChange: () => {},
        text: '',
        rows: 3,
        cols: 50,
        value: '',
    };

    onChange = (e) => {
        this.props.onChange(e.target.value);
    };

    render() {
        return (
            <div className={`component-Input-TextArea`}>
                <textarea
                    onBlur={this.props.onBlur}
                    className={this.props.class}
                    data-gramm_editor="false"
                    data-qa={this.props.qaDataAttr}
                    name={this.props.name}
                    placeholder={this.props.placeholder}
                    onChange={this.onChange}
                    style={this.props.customStyle}
                    rows={this.props.rows}
                    cols={this.props.cols}
                    defaultValue={this.props.value}
                    onFocus={this.props.onFocus}
                    ref={this.props.refs}
                ></textarea>
            </div>
        );
    }
}
